import { Container as ChakraContainer, ContainerProps } from '@chakra-ui/react';

const Container = ({ children, ...props }: ContainerProps) => (
  <ChakraContainer
    maxW='container.xl'
    display='flex'
    flexDir='column'
    p={0}
    {...props}
  >
    {children}
  </ChakraContainer>
);

export default Container;
